export default __webpack_public_path__ + "static/media/PostgreDB.bf965d10.svg";